import VueTypes from 'vue-types'

export const BadgeItem = VueTypes.shape({
    name: VueTypes.string.isRequired,
    color: VueTypes.oneOfType([String, null]).def(null),
    backgroundColor: VueTypes.oneOfType([String, null]).def(null),
}).isRequired;

export const createBadgeItem = ({
    name, color, backgroundColor
}) => {
    return {
        name: name,
        color: color,
        backgroundColor: backgroundColor,
    }
}